import React, {useContext, useEffect, useState} from 'react';
import './Login.css'
import logo from '../../accets/img/Logo.png'
import {useNavigate} from "react-router-dom";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import ModalLogin from "../Modal/ModalLogin";

const Login = () => {

    const navigate = useNavigate()

    const {userStore, settingStore} = useContext(Context)

    const [nickname, setNickname] = useState('')
    const [password, setPassword] = useState('')
    const [active, setActive] = useState(false)

    useEffect(() => {
        if (localStorage.getItem('token') && userStore.isAuth) {
            navigate('/job/task')
        }
    }, [userStore.isAuth])

    const signIn = () => {
        userStore.login(nickname.toLowerCase(), password, setActive)
    }

    return (
        <div className="screen__block">
            <div className="screen-1">
                <div className="logo__login">
                    <img src={logo} alt={logo}/>
                </div>
                <div className="email">
                    <label htmlFor="email">Ваш логин</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setNickname(e.target.value)} value={nickname} type="text" name="nickname"
                               placeholder="Login"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="password">Пароль</label>
                    <div className="sec-2">
                        <ion-icon name="lock-closed-outline"></ion-icon>
                        <input onChange={e => setPassword(e.target.value)} value={password} className="pas"
                               type="password" name="password" placeholder="············"/>
                        <ion-icon className="show-hide" name="eye-outline"></ion-icon>
                    </div>
                </div>
                {nickname !== '' && password !== ''
                    ?
                    <button className="login" onClick={signIn}>Войти</button>
                    :
                    <button className="login__dis">Введите логин и пароль</button>
                }

                {settingStore.setting.filter(i => i.namePar === 'noReg').map(j => {
                    if (!j.value) {
                        return <div key={j.id} className="footer"><span onClick={() => navigate('/registration')}>Регистрация</span></div>
                    }
                })
                }
                {settingStore.setting.filter(i => i.namePar === 'noReg').length === 0
                    &&
                    <div className="footer"><span onClick={() => navigate('/registration')}>Регистрация</span></div>
                }

            </div>
            <ModalLogin active={active} setActive={setActive}/>
        </div>

    );
};

export default observer(Login);